import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setFilter } from "../../features/filter/filterSlice";

export default function Header() {
  const dispatch = useDispatch();
  const [filter, setNewFilter] = useState("All");

  const handleFilter = (e, value) => {
    setNewFilter(value);

    if (value === "All") {
      dispatch(setFilter(value));
    } else if (value === "Featured") {
      dispatch(setFilter(value));
    }
  };
  return (
    <div className="flex items-center justify-between mb-12">
      <h4 className="mt-2 text-xl font-bold">Book List</h4>

      <div className="flex items-center space-x-4">
        <button
          className={`lws-filter-btn ${
            filter === "All" ? "active-filter" : ""
          }`}
          onClick={(e) => handleFilter(e, "All")}
        >
          All
        </button>
        <button
          className={`lws-filter-btn ${
            filter === "Featured" ? "active-filter" : ""
          }`}
          onClick={(e) => handleFilter(e, "Featured")}
        >
          Featured
        </button>
      </div>
    </div>
  );
}
